<template>
  <div>
    <v-dialog v-if="!loading" width="1000" v-model="show">
      <slot slot="activator" name="activator">
        <v-btn  slot="activator">
          <v-icon>add</v-icon>
        </v-btn>
      </slot>
      <AddAction  @subscriberCreated="addSubscriber($event)" :templates="templates" :schema="schema" :subscriberTypes="subscriberTypes"></AddAction>
    </v-dialog>

    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <v-data-table v-if="!loading"
                  :headers="headers"
                  :items="subscribers"
                  :loading="loading"
                  no-data-text="-"
                  no-results-text="-"
                  :rows-per-page-items="[10,25,50]"
                  class="elevation-1">

      <template v-slot:items="props">
        <td>{{ getActionDescription(props.item.type) }}</td>
        <td>{{ getEventName(props.item.event) }}</td>
        <td>
          <span v-for="(value, property) in props.item.data" :key="'action-' + property" style="display: block">
            {{ getActionPropertyDescription(props.item.type, property) }}
            :
            {{getValueToShow(props.item.type, property, value)}}
          </span>
        </td>
        <td>
          <v-btn icon @click="deleteItem(props.item.id)">
            <v-icon>
              delete
            </v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>

  </div>
</template>

<script>
import eventActionType from "../../../enums/eventActionType"
import AddAction from "./AddAction.vue"

export default {
  components:{AddAction},
  data() {
    return {
      subscribers:[],
      subscriberTypes:[],
      loading:true,
      schema: {},
      model: {},
      show:false,
      templates: [],
      schemaFields: [],
      headers:[
        { text: 'Akcja', value: 'type' },
        { text: 'Wydarzenie', value: 'event' },
        { text: 'Własciwości', value: 'data' },
        { text: 'Akcje', value: '_' }
      ]

    }
  },
  computed: {
    fields() {
      let fields = []
      this.schemaFields.forEach(field => {
        fields.push(field)
        if (field['sub-fields'] != undefined) {
          field['sub-fields'].forEach(subField => fields.push(subField))
        }
      })
      return fields
    }
  },
  watch: {},
  created() {
    this.loading = true
    let schema = this.$http.get('schema/' + this.$route.params.schemaId)
    let subscribers = this.$http.get('schema/' + this.$route.params.schemaId + '/subscribers')
    let subscriberTypes = this.$http.get('/subscribers')
    let templates = this.$http.get('templates/' + this.$route.params.schemaId)

    Promise.all([schema, subscribers, subscriberTypes, templates]).then((data) => {
      this.schema = data[0].data
      this.subscribers = data[1].data,
      this.subscriberTypes = data[2].data
      this.templates = data[3].data
    }).catch(() => {
      this.$route.push({
        name: "not-found"
      })
    }).finally(() => this.loading = false)
  },
  methods: {
    addSubscriber(subscriber){
      this.subscribers = [subscriber].concat(this.subscribers)
      this.show=false
    },
    getValueToShow(actionName,propertyName,value){
      let property = this.getProperty(actionName,propertyName)

      if(!property){
        return value
      }

      switch (property.type) {
      case 'templateId':
        return this.getTemplateName(value)
      case 'password':
        return '***'
      case 'fieldOrder':
      case 'relatedFieldOrder':
        return this.getFieldName(value)
      case 'checkbox':
        return (value == true || value === 'true') ? '✓' : '✕'
      default:
        return value
      }
    },
    getFieldName(order){
      let field = this.schema.fields.find(field => field.order == order)
      return field ? field.name : order
    },
    getTemplateName(id){
      let template = this.templates.find(el => el.id == id)
      return template ? template.name : id
    },
    getProperty(actionType, propertyName){
      let action = this.subscriberTypes.find(el => el.name == actionType)
      return action ? action.properties.fields.find(el => el.name == propertyName) : null
    },
    getActionPropertyDescription(actionType, propertyName){
      let property = this.getProperty(actionType,propertyName)
      return property ? property.description : "Nieznana własciwość"
    },
    getActionDescription(type){
      let action = this.subscriberTypes.find(el => el.name == type)
      return action ? action.description : "?"
    },
    getEventName(event){
      return eventActionType.getEventName(event)
    },
    deleteItem(id){
      this.$confirm(this.$t('cyclic.uare_sure'))
        .then(res => {
          if (res) {
            this.$http.delete(`subscriber/${id}`).then(() => {
              this.subscribers = this.subscribers.filter(el => el.id != id)
            })
          }
        })
    }
  },
}
</script>
